import { EthereumWalletConnectors } from '@dynamic-labs/ethereum'
import { DynamicContextProvider, useDynamicContext } from '@dynamic-labs/sdk-react-core'
import { loginUser } from '../api/api'
import useToken from '../hooks/useToken'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { AxiosError } from 'axios'

const environmentId = process.env.REACT_APP_DYNAMIC_LABS_ENVIROMENT_ID

interface DynamicProviderProps {
  children: React.ReactNode
}

function DynamicProvider({ children }: DynamicProviderProps) {
  const { setToken } = useToken()
  const navigate = useNavigate()

  return environmentId ? (
    <DynamicContextProvider
      settings={{
        environmentId,
        initialAuthenticationMode: 'connect-and-sign',
        recommendedWallets: [
          { walletKey: 'metamask', label: 'Popular' },
          { walletKey: 'phantomevm', label: 'Popular' },
          { walletKey: 'coinbase', label: 'Popular' },
        ],
        events: {
          onAuthSuccess: async (args) => {
            console.log({ args })

            const authToken = localStorage.getItem('dynamic_min_authentication_token')?.slice(1, -1)

            if (!authToken) return

            const payload: { email?: string; address?: string; token: string } = {
              token: authToken,
            }
            if (args.user.email) {
              payload.email = args.user.email
            } else if (args.primaryWallet?.address) {
              payload.address = args.primaryWallet.address
            }

            if (payload.email) {
              try {
                await loginUser({
                  email: payload.email,
                  token: authToken,
                })

                setToken(authToken)
                navigate('/')
              } catch (error) {
                if (error instanceof AxiosError) {
                  if (error.response?.status === 403) {
                    toast.error('You are not authorized to access this page')
                  } else {
                    toast.error('Something went wrong')
                  }
                }
                args.handleLogOut()
              }
            } else {
              toast.error('Please login with your email')
            }
          },
        },
      }}
    >
      {children}
    </DynamicContextProvider>
  ) : (
    children
  )
}

export default DynamicProvider
